const sendManagerRequest = {
  sendRequest: 'Enviar solicitud',
  personalManagerRequest: 'Solicitud de administrador personal',
  pleaseFillYourProfile: 'Por favor, complete su perfil y deje sus datos de contacto para una mejor comunicación.',
  myContact: 'Mi contacto',
  messengerId: 'Su ID de Messenger',
  messenger: 'Messenger',
  requestForPersonalManager: 'Su solicitud de administrador personal ha sido enviada. Su nuevo administrador personal se pondrá en contacto con usted en breve.',
};

export default sendManagerRequest;
